import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IDynamicTableColumn } from 'src/app/core/models/dynamic-table-column.vm';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DataSharingConsentProductId, ProductsTableColumns } from './product-detail-layouts';
import { LoaderService } from 'src/app/core/services/loader.service';
import { Constants } from 'src/app/core/constants/constants';
import { ILayout } from 'src/app/core/models/layout.vm';
import { Layout } from 'src/app/core/classes/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/core/services/product.service';
import { IProductOrganisations } from 'src/app/core/models/product-organisations.vm';
import { IProductListItem } from 'src/app/core/models/product-list-item.vm';

@Component({
  selector: 'app-products-detail',
  templateUrl: './products-detail.component.html',
  styleUrls: ['./products-detail.component.scss']
})
export class ProductsDetailComponent implements OnInit, OnDestroy {
  @Input() public currentProduct: any;
  @Input() public currentYear: number;
  public layout: ILayout;

  private unsubscribe = new Subject();
  public productOrganisationList: Array<IProductOrganisations>
  public organisationTableColumns: Array<IDynamicTableColumn> = ProductsTableColumns;
  public loadingError: string = null;
  public currentUrlParams: any;
  public products: Array<IProductListItem> = [];
  public currentProductInfo: IProductListItem;


  constructor(
    private productService: ProductService,
    public loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,

  ) { }
  
  ngOnInit(): void {
    this.getOptions()
    // Route params fire immediately, so the organisation list is requested there
    // rather than here as well
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      this.currentUrlParams = params;
      this.routeChange(params);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public yearChange(year: any): void {
    this.currentYear = year
    this.router.navigate(['products',this.currentYear, this.currentProduct]);

  }

  routeChange(params){
    this.currentProduct = params.id
    this.currentYear = params.year || Constants.currentYear;
    this.productOrganisationList = null
    this.organisationTableColumns = this.currentProduct == DataSharingConsentProductId
      ? ProductsTableColumns
      : ProductsTableColumns.filter(column => column.dataKey !== 'dataSharingConsent')
    this.setLayout()
    this.getOrganisationList(this.currentProduct, this.currentYear)
  }


  private getOrganisationList(productId: number, year: number): void {
    this.productService.getOrganisationProduct(productId, year).pipe(takeUntil(this.unsubscribe)).subscribe(
      success => { 
          this.productOrganisationList = success.data.productOrgList
          this.productOrganisationList.forEach(a => a.overrideFee ? a.bandFee = a.overrideFee : null)
          this.setLayout()
      },
      error => { 
        this.loadingError = 'Unable to load the organisation list for this product.';
        console.log('Error: ', error);
      }
    )
  }

  public getOptions(){
    this.productService.getOrganisationProductOptions().pipe(takeUntil(this.unsubscribe)).subscribe(
      success => {
        this.products = success.data.availableProductList || []
        this.setLayout()
      },
      error => {
        this.loadingError = 'Unable to load the product list.';
        console.log('Error: ', error);
      }
    )
  }

  private setLayout(): void {
    const currentProduct: any = this.currentProduct
    this.currentProductInfo = this.products.find(a => a.productId == currentProduct)
    if (!this.currentProductInfo) {
      return
    }
    const subheading: Array<string> = [this.currentProductInfo.productAlias]
    if (this.productOrganisationList) {
      subheading.push(`${this.productOrganisationList.length} organisations`)
    }
    this.layout = new Layout(
      this.currentProductInfo.productName,
      subheading,
      `/products/${this.currentYear}`
    );
  }

  public onTableClick = (primaryKey: any): void =>{
    this.router.navigate([`/organisation/${this.currentYear}/${primaryKey}/products`],);
  }

}
